import * as _ from 'underscore';

import { IPublishedConnectionDetailInfo, IPublishedConnectionInfo } from '../models/IPublishedConnectionInfo';
import { IUserInfo } from '../models/IUserInfo';
import { INamedItemInfo } from '../models/resourceInfoParts';
import { IPublishedConnection, IPublishedConnectionDetail } from '../ServerApi/types/IPublishedConnection';
import { IPublishedConnectionUsageInfo } from '../ServerApi/types/IUsageInfo';
import { MapperHelper } from './MapperHelper';
import { ProjectMapper } from './ProjectMapper';
import { UserMapper } from './UserMapper';

export module PublishedConnectionMapper {
  const M = MapperHelper;

  export function map(
    serverApiMetrics: IPublishedConnection[],
    users: _.Dictionary<IUserInfo>,
    projects: _.Dictionary<INamedItemInfo>,
    favoritePublishedConnections: _.Dictionary<any> = {}
  ): IPublishedConnectionInfo[] {
    return serverApiMetrics.map((m: IPublishedConnection) => {
      return mapOne(m, users[m.ownerId], projects[m.projectId], !!favoritePublishedConnections[m.id]);
    });
  }

  // TODO - achristian - 2020-02-19 - TFSID: 1059566 - Fix mocking
  export function mapOne(
    publishedConnection: IPublishedConnection,
    owner?: IUserInfo,
    project?: INamedItemInfo,
    favorite?: boolean
  ): IPublishedConnectionInfo {
    return {
      createdAt: M.toDate(publishedConnection.createdAt),
      updatedAt: M.toDate(publishedConnection.updatedAt),
      description: publishedConnection.description,
      id: publishedConnection.id,
      luid: publishedConnection.luid,
      name: publishedConnection.name,
      owner: UserMapper.mapOne(owner),
      favorite: favorite,
      contentType: 'publishedConnection',
      tags: M.sortTags(publishedConnection.tags),
      project: project,
      usageInfo: <IPublishedConnectionUsageInfo>{favoritesTotal: 0},
      usageInfoMaxValues: <IPublishedConnectionUsageInfo>{},
    };
  }

  // TODO - achristian - 2020-02-19 - TFSID: 1059566 - Fix mocking
  export function mapDetail(p: IPublishedConnectionDetail): IPublishedConnectionDetailInfo {
    return {
      createdAt: M.toDate(p.createdAt),
      updatedAt: M.toDate(p.updatedAt),
      description: p.description,
      id: p.id,
      luid: p.luid,
      name: p.name,
      owner: UserMapper.mapOne(p.owner),
      favorite: p.favorite,
      contentType: 'publishedConnection',
      tags: M.sortTags(p.tags),
      project: ProjectMapper.mapName(p.project),
      tables: p.tables
    };
  }

  // TODO - achristian - 2020-02-19 - TFSID: 1059566 - Fix mocking
  export function mapFromCRASS(p: any): IPublishedConnectionInfo {
    return {
      createdAt: M.toDate(p.createdTime) || M.toDateFromTimeOffsetObject(p.createdTime),
      updatedAt: M.toDate(p.modifiedTime) || M.toDateFromTimeOffsetObject(p.modifiedTime),
      description: p.description,
      id: p.id + '',
      luid: p.luid,
      name: p.title,
      favorite: false,
      contentType: 'publishedConnection',
      tags: M.sortTags(p.tags),
      project: null,
      owner: UserMapper.mapOneOwnerFromCRASS(p),
      usageInfo: <IPublishedConnectionUsageInfo>{favoritesTotal: 0},
      usageInfoMaxValues: <IPublishedConnectionUsageInfo>{}
    };
  }
}
